import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import "./Header.scss";
import pepfarHeaderLogo from "assets/images/US Flag - DOS Seal 2025.png";

import { useSelector, useDispatch } from "react-redux";
import { selectapp, toggleTheme } from "stateMgmt/appSlice";

// import logger from "services/LoggingService";

import PropTypes from "prop-types";

const Header = (props) => {
  const appContext = useSelector(selectapp).context;
  const theme = useSelector(selectapp).theme;
  const dispatch = useDispatch();
  const [isDark, setMode] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const toggleMode = () => {
    dispatch(toggleTheme({}));
    const newMode = !isDark;
    setMode(newMode);
  };

  useEffect(() => {
    const mode = localStorage.getItem("dark") === "true";
    setMode(mode);
    const hide = appContext !== "home";
    setIsHidden(hide);
  });

  return (
    <header>
      <div>
        <nav
          className="flex-md-nowrap p-0 nav-style"
          style={{ borderBottom: theme.headerBorder, background: theme.headerBackgroundColor }}
          aria-hidden={isHidden}
          // tabIndex={isHidden ? -1 : 0}
        >
          <NavLink
            data-testid="logo"
            className="logo-anchor"
            to="/"
            aria-label="United States Presidents emergency plan for AIDS relief logo. "
            exact={"true"}
          >
            <picture>
              
              <source srcSet={pepfarHeaderLogo} type="image/png" />
              <img src={pepfarHeaderLogo} alt="PEPFAR Logo" />
            </picture>
            <span
              id="site-start"
              role="heading"
              className="header__title-text"
              tabIndex={isHidden ? -1 : 1}
            >
              PEPFAR Panorama Spotlight 
            </span>
          </NavLink>
          <span
            className="header__dropdown-menu"
            onClick={props.dropDownMenuClickHandler}
            tabIndex={-1}
          >
            Menu
          </span>
          <div
            data-testid="light-btn"
            className={isDark ? "modeDiv" : "hidden"}
          >
            <LightModeOutlinedIcon
              sx={{ fontSize: "36px" }}
              data-testid="light-mode"
              aria-label="Turn off dark mode"
              onClick={() => toggleMode()}
            />
          </div>
          <div data-testid="dark-btn" className={isDark ? "hidden" : "modeDiv"}>
            <DarkModeOutlinedIcon
              sx={{ fontSize: "36px" }}
              data-testid="dark-mode"
              aria-label="Turn on dark mode"
              onClick={() => toggleMode()}
            />
          </div>
        </nav>
      </div>
    </header>
  );
};

Header.propTypes = {
  dropDownMenuClickHandler: PropTypes.func,
};

export default Header;
